/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Notsubscribedapi2Inputs */

const id_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API tidak berlangganan notifikasi push`)
};

const ms_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API tidak dilanggan pada pemberitahuan push`)
};

const da_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-nøglen er ikke abonneret på push-notifikationer`)
};

const de_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüssel ist nicht für Push-Benachrichtigungen abonniert`)
};

const en_us2_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key is not subscribed to push notifications`)
};

const es_es2_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La clave de API no está suscrita a las notificaciones push`)
};

const es_mx2_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La clave de API no está suscrita a las notificaciones push`)
};

const fil_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang API key ay hindi naka-subscribe sa push notifications`)
};

const fr_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La clé API n'est pas abonnée aux notifications push`)
};

const it_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La chiave API non è iscritta alle notifiche push`)
};

const hu_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API kulcs nincs feliratkozva push értesítésekre`)
};

const nl_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-sleutel is niet geabonneerd op pushmeldingen`)
};

const no_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-nøkkel er ikke abonnert på push-varsler`)
};

const pl_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klucz API nie jest subskrybowany do powiadomień push`)
};

const pt_br2_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A chave API não está inscrita em notificações push`)
};

const pt_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A chave de API não está subscrita a notificações push`)
};

const ro_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheia API nu este abonată la notificări push`)
};

const fi_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-avain ei ole tilannut push-ilmoituksia`)
};

const sv_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-nyckeln prenumererar inte på push-notiser`)
};

const vi_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khóa API chưa đăng ký thông báo đẩy`)
};

const tr_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API anahtarı push bildirimlerine abone değil`)
};

const cs_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API klíč není přihlášen k odběru push oznámení`)
};

const bg_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API ключът не е абониран за push известия`)
};

const ru_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-ключ не подписан на push-уведомления`)
};

const uk_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-ключ не підписаний на push-сповіщення`)
};

const ar_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مفتاح API غير مشترك في الإشعارات الفورية`)
};

const hi_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API कुंजी पुश सूचनाओं के लिए सब्सक्राइब नहीं है`)
};

const th_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คีย์ API ยังไม่ได้สมัครรับการแจ้งเตือนแบบพุช`)
};

const ja_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API キーはプッシュ通知に購読していません`)
};

const zh_cn2_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API密钥未订阅推送通知`)
};

const zh_hant1_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API金鑰未訂閱推播通知`)
};

const ko_notifications_notsubscribedapi2 = /** @type {(inputs: Notifications_Notsubscribedapi2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 키가 푸시 알림에 구독되어 있지 않음`)
};

/**
* | output |
* | --- |
* | "API key is not subscribed to push notifications" |
*
* @param {Notifications_Notsubscribedapi2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_notsubscribedapi2 = /** @type {((inputs?: Notifications_Notsubscribedapi2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Notsubscribedapi2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_notsubscribedapi2(inputs)
	if (locale === "ms") return ms_notifications_notsubscribedapi2(inputs)
	if (locale === "da") return da_notifications_notsubscribedapi2(inputs)
	if (locale === "de") return de_notifications_notsubscribedapi2(inputs)
	if (locale === "en-US") return en_us2_notifications_notsubscribedapi2(inputs)
	if (locale === "es-ES") return es_es2_notifications_notsubscribedapi2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_notsubscribedapi2(inputs)
	if (locale === "fil") return fil_notifications_notsubscribedapi2(inputs)
	if (locale === "fr") return fr_notifications_notsubscribedapi2(inputs)
	if (locale === "it") return it_notifications_notsubscribedapi2(inputs)
	if (locale === "hu") return hu_notifications_notsubscribedapi2(inputs)
	if (locale === "nl") return nl_notifications_notsubscribedapi2(inputs)
	if (locale === "no") return no_notifications_notsubscribedapi2(inputs)
	if (locale === "pl") return pl_notifications_notsubscribedapi2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_notsubscribedapi2(inputs)
	if (locale === "pt") return pt_notifications_notsubscribedapi2(inputs)
	if (locale === "ro") return ro_notifications_notsubscribedapi2(inputs)
	if (locale === "fi") return fi_notifications_notsubscribedapi2(inputs)
	if (locale === "sv") return sv_notifications_notsubscribedapi2(inputs)
	if (locale === "vi") return vi_notifications_notsubscribedapi2(inputs)
	if (locale === "tr") return tr_notifications_notsubscribedapi2(inputs)
	if (locale === "cs") return cs_notifications_notsubscribedapi2(inputs)
	if (locale === "bg") return bg_notifications_notsubscribedapi2(inputs)
	if (locale === "ru") return ru_notifications_notsubscribedapi2(inputs)
	if (locale === "uk") return uk_notifications_notsubscribedapi2(inputs)
	if (locale === "ar") return ar_notifications_notsubscribedapi2(inputs)
	if (locale === "hi") return hi_notifications_notsubscribedapi2(inputs)
	if (locale === "th") return th_notifications_notsubscribedapi2(inputs)
	if (locale === "ja") return ja_notifications_notsubscribedapi2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_notsubscribedapi2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_notsubscribedapi2(inputs)
	return ko_notifications_notsubscribedapi2(inputs)
});
export { notifications_notsubscribedapi2 as "notifications.notSubscribedApi" }